document.addEventListener('click', function(e) {
  const root = e.target.closest('#blazer-sizeguide-root');
  if (!root) return;

  const mainBtn = e.target.closest('[data-blazer-main-unit]');
  if (mainBtn && root.contains(mainBtn)) {
    const unit = mainBtn.getAttribute('data-blazer-main-unit');

    root.querySelectorAll('[data-blazer-main-unit]').forEach(function(btn) {
      const active = btn === mainBtn;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    root.querySelectorAll('[data-blazer-main-panel]').forEach(function(panel) {
      panel.style.display = panel.getAttribute('data-blazer-main-panel') === unit ? '' : 'none';
    });

    return;
  }

  const pantsBtn = e.target.closest('[data-blazer-pants-unit]');
  if (pantsBtn && root.contains(pantsBtn)) {
    const unit = pantsBtn.getAttribute('data-blazer-pants-unit');

    root.querySelectorAll('[data-blazer-pants-unit]').forEach(function(btn) {
      const active = btn === pantsBtn;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    root.querySelectorAll('[data-blazer-pants-panel]').forEach(function(panel) {
      panel.style.display = panel.getAttribute('data-blazer-pants-panel') === unit ? '' : 'none';
    });
  }
});


/* =========================================================
   GlazyBoo Cart Page BOGO Free Lash Selector — v25 Locked Quantity Input

   Important:
   - theme.js is patched to call window.GlazyBooBogoBeforeCartRefresh()
     after Symmetry updates cart quantities, but BEFORE Symmetry refreshes the cart HTML.
   - This means the cart refresh happens once, with paid quantity + hidden free gifts
     already synced.
   - Normal products stay baseline.
   ========================================================= */
(function () {
  var CONFIG = {
    paidProductHandle: 'glazylash-reusable-adhesive-eyelashes',
    freeProductHandle: 'glazylash-reusable-adhesive-eyelashes-free',

    styles: [
      {
        label: 'Natural',
        paidVariantId: 43756305907966,
        freeVariantId: 54756149723462,
        image: 'https://cdn.shopify.com/s/files/1/0666/3172/9406/products/Natural.png?v=1671400083'
      },
      {
        label: 'Long',
        paidVariantId: 43756305973502,
        freeVariantId: 54756149756230,
        image: 'https://cdn.shopify.com/s/files/1/0666/3172/9406/products/Long.png?v=1671400083'
      },
      {
        label: 'Thick',
        paidVariantId: 43756305940734,
        freeVariantId: 54756149788998,
        image: 'https://cdn.shopify.com/s/files/1/0666/3172/9406/products/Thick.png?v=1671400083'
      }
    ],

    propertyGift: '_glazyboo_bogo_gift',
    propertySlot: '_glazyboo_bogo_slot',
    propertyParent: '_glazyboo_bogo_parent',
    propertyStyle: '_glazyboo_bogo_style'
  };

  var syncing = false;
  var checkoutInProgress = false;
  var maskTimer = null;

  function isCartPage() {
    return window.location.pathname.replace(/\/$/, '') === '/cart';
  }

  function hasRoot() {
    return !!document.querySelector('[data-glazyboo-bogo-root]');
  }

  function updateBogoBodyScope() {
    document.body.classList.toggle('glazyboo-bogo-cart-active', hasRoot());
  }

  function setCartMask(active) {
    document.body.classList.toggle('glazyboo-bogo-cart-mask-active', !!active);

    if (maskTimer) {
      clearTimeout(maskTimer);
      maskTimer = null;
    }

    if (active) {
      maskTimer = setTimeout(function () {
        document.body.classList.remove('glazyboo-bogo-cart-mask-active');
      }, 2500);
    }
  }

  function getPaidVariantIds() {
    return CONFIG.styles.map(function (style) {
      return Number(style.paidVariantId);
    });
  }

  function getFreeVariantIds() {
    return CONFIG.styles.map(function (style) {
      return Number(style.freeVariantId);
    });
  }

  function getStyleByPaidVariantId(variantId) {
    variantId = Number(variantId);
    return CONFIG.styles.find(function (style) {
      return Number(style.paidVariantId) === variantId;
    }) || CONFIG.styles[0];
  }

  function getStyleByFreeVariantId(variantId) {
    variantId = Number(variantId);
    return CONFIG.styles.find(function (style) {
      return Number(style.freeVariantId) === variantId;
    }) || CONFIG.styles[0];
  }

  function isGiftItem(item) {
    return !!(item.properties && String(item.properties[CONFIG.propertyGift]) === 'true');
  }

  function isEligiblePaidItem(item) {
    /* Lash BOGO owns lash lines only. Halo 1+1 lines are reconciled separately. */
    return getPaidVariantIds().indexOf(Number(item.variant_id)) !== -1 &&
      !isGiftItem(item) &&
      !haloRole(item);
  }

  function isFreeGiftVariant(item) {
    return getFreeVariantIds().indexOf(Number(item.variant_id)) !== -1;
  }

  function getSlot(item) {
    return item.properties && item.properties[CONFIG.propertySlot]
      ? String(item.properties[CONFIG.propertySlot])
      : '';
  }

  function getCart() {
    return fetch('/cart.js', {
      method: 'GET',
      cache: 'no-store',
      headers: { 'Accept': 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not read cart');
      return response.json();
    });
  }

  function changeLineQuantity(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: Math.max(0, Number(quantity || 0))
      })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () { return {}; }).then(function (json) {
          throw new Error(json.description || json.message || 'Could not update cart line');
        });
      }

      return response.json();
    });
  }

  function haloRole(item) {
    return item && item.properties ? String(item.properties._GlazyBoo_bundle || '').trim() : '';
  }

  function haloBundleId(item) {
    return item && item.properties ? String(item.properties._GlazyBoo_halo_bundle_id || '').trim() : '';
  }

  function isHaloPaid(item) {
    return !isGiftItem(item) && haloRole(item) === 'Wavy paid pair';
  }

  function isHaloFree(item) {
    return !isGiftItem(item) && haloRole(item) === 'Straight free pair';
  }

  function parseHaloBundleId(bundleId) {
    var match = String(bundleId || '').match(/^halo-(\d+)-(\d+)$/);
    if (!match) return null;
    return { paidVariantId: Number(match[1]), straightVariantId: Number(match[2]) };
  }

  function addHaloFree(freeVariantId, quantity, bundleId) {
    quantity = Math.max(0, Number(quantity || 0));
    if (!freeVariantId || quantity < 1) return Promise.resolve(false);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: Number(freeVariantId),
          quantity: quantity,
          properties: {
            '_GlazyBoo_bundle': 'Straight free pair',
            '_GlazyBoo_halo_bundle_id': String(bundleId || '')
          }
        }]
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not add matching Straight Halo');
      return response.json();
    });
  }

  function runHaloOperations(ops) {
    if (!ops.length) return Promise.resolve(false);
    return ops.reduce(function (promise, op) {
      return promise.then(op);
    }, Promise.resolve()).then(function () { return true; });
  }

  function reconcileHaloBundles() {
    return getCart().then(function (cart) {
      var paidGroups = {};
      var freeByBundle = {};

      (cart.items || []).forEach(function (item) {
        if (isHaloFree(item)) {
          var freeId = haloBundleId(item);
          if (freeId) {
            freeByBundle[freeId] = freeByBundle[freeId] || [];
            freeByBundle[freeId].push(item);
          }
          return;
        }
        if (!isHaloPaid(item)) return;
        var key = String(item.variant_id);
        paidGroups[key] = paidGroups[key] || [];
        paidGroups[key].push(item);
      });

      var normalizeOps = [];
      Object.keys(paidGroups).forEach(function (variantId) {
        var group = paidGroups[variantId];
        if (group.length < 2) return;
        var totalQty = group.reduce(function (sum, item) { return sum + Number(item.quantity || 0); }, 0);
        var keeper = group.find(function (item) {
          var id = haloBundleId(item);
          return id && freeByBundle[id] && freeByBundle[id].length;
        }) || group[0];

        if (Number(keeper.quantity || 0) !== totalQty) {
          normalizeOps.push(function () { return changeLineQuantity(keeper.key, totalQty); });
        }
        group.forEach(function (item) {
          if (item.key === keeper.key) return;
          normalizeOps.push(function () { return changeLineQuantity(item.key, 0); });
        });
      });

      return runHaloOperations(normalizeOps).then(function (normalized) {
        return normalized ? getCart() : cart;
      }).then(function (freshCart) {
        var groups = {};
        var inferredStraightByPaid = {};

        (freshCart.items || []).forEach(function (item) {
          if (!isHaloPaid(item) && !isHaloFree(item)) return;
          var id = haloBundleId(item);
          if (!id) return;
          groups[id] = groups[id] || { paid: [], free: [] };
          if (isHaloPaid(item)) groups[id].paid.push(item);
          if (isHaloFree(item)) groups[id].free.push(item);
        });

        Object.keys(groups).forEach(function (id) {
          var group = groups[id];
          if (group.paid.length && group.free.length) {
            inferredStraightByPaid[Number(group.paid[0].variant_id)] = Number(group.free[0].variant_id);
          }
        });

        var ops = [];
        Object.keys(groups).forEach(function (id) {
          var group = groups[id];
          var paidQty = group.paid.reduce(function (sum, item) { return sum + Number(item.quantity || 0); }, 0);

          if (paidQty < 1) {
            group.free.forEach(function (item) {
              ops.push(function () { return changeLineQuantity(item.key, 0); });
            });
            return;
          }

          var freeVariantId = group.free.length ? Number(group.free[0].variant_id) : 0;
          if (!freeVariantId) {
            var parsed = parseHaloBundleId(id);
            if (parsed) freeVariantId = parsed.straightVariantId;
          }
          if (!freeVariantId && group.paid.length) {
            freeVariantId = Number(inferredStraightByPaid[Number(group.paid[0].variant_id)] || 0);
          }

          if (!group.free.length) {
            if (freeVariantId) {
              ops.push(function () { return addHaloFree(freeVariantId, paidQty, id); });
            }
            return;
          }

          var keeper = group.free[0];
          if (Number(keeper.quantity || 0) !== paidQty) {
            ops.push(function () { return changeLineQuantity(keeper.key, paidQty); });
          }
          group.free.slice(1).forEach(function (item) {
            ops.push(function () { return changeLineQuantity(item.key, 0); });
          });
        });

        return runHaloOperations(ops).then(function (synced) {
          return normalized || synced;
        });
      });
    });
  }

  function addGift(freeVariantId, slot, styleName) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: Number(freeVariantId),
        quantity: 1,
        properties: {
          '_glazyboo_bogo_gift': 'true',
          '_glazyboo_bogo_slot': String(slot),
          '_glazyboo_bogo_parent': CONFIG.paidProductHandle,
          '_glazyboo_bogo_style': styleName || ''
        }
      })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () { return {}; }).then(function (json) {
          throw new Error(json.description || json.message || 'Could not add free lash');
        });
      }

      return response.json();
    });
  }

  function buildPaidSlots(cart) {
    var slots = [];

    cart.items.forEach(function (item) {
      if (!isEligiblePaidItem(item)) return;

      var matchedStyle = getStyleByPaidVariantId(item.variant_id);
      var qty = Number(item.quantity || 0);

      for (var i = 0; i < qty; i++) {
        slots.push({
          defaultFreeVariantId: Number(matchedStyle.freeVariantId),
          defaultStyle: matchedStyle.label
        });
      }
    });

    return slots;
  }

  function getGiftMap(cart) {
    var map = {};
    var extras = [];

    cart.items.forEach(function (item) {
      if (!isGiftItem(item)) return;

      var slot = getSlot(item);

      if (!slot || map[slot]) {
        extras.push(item);
        return;
      }

      map[slot] = item;
    });

    return {
      map: map,
      extras: extras
    };
  }

  function runOperationsSequentially(operations) {
    return operations.reduce(function (promise, operation) {
      return promise.then(operation);
    }, Promise.resolve());
  }

  function setRootSyncing(isSyncing) {
    var root = document.querySelector('[data-glazyboo-bogo-root]');
    if (!root) return;
    root.classList.toggle('glazyboo-bogo-is-syncing', !!isSyncing);
  }

  function revealCartAnimatedElements() {
    document.querySelectorAll('[data-section-type="cart-template"] [data-cc-animate]').forEach(function (element) {
      element.classList.add('-in');
      element.style.opacity = '';
      element.style.transform = '';
    });
  }

  function lockBogoQuantityInputs() {
    /*
      Only locks direct typing on the paid GlazyLash BOGO quantity field.
      Plus/minus buttons still work. Normal product quantity inputs stay baseline.
    */
    document.querySelectorAll('[data-glazyboo-paid-line="true"] .cart-item__quantity-input, [data-glazyboo-paid-line="true"] input[name^="updates"]').forEach(function (input) {
      input.setAttribute('readonly', 'readonly');
      input.setAttribute('inputmode', 'none');
      input.setAttribute('aria-readonly', 'true');
      input.classList.add('glazyboo-bogo-qty-input-locked');
      input.title = 'Use the + and - buttons to update quantity';
    });
  }

  function hideHiddenFreeGiftRowsImmediately() {
    document.querySelectorAll('.product-glazylash-reusable-adhesive-eyelashes-free, [data-glazyboo-hidden-gift-line="true"], .glazyboo-bogo-hidden-gift-line').forEach(function (node) {
      var line = node.closest('[data-merge-list-item]') || node.closest('[data-glazyboo-line-key]') || node;
      line.classList.add('glazyboo-bogo-hidden-gift-line');
      line.setAttribute('data-glazyboo-hidden-gift-line', 'true');
      line.setAttribute('aria-hidden', 'true');
      line.style.setProperty('display', 'none', 'important');
      line.style.setProperty('visibility', 'hidden', 'important');
      line.style.setProperty('height', '0', 'important');
      line.style.setProperty('overflow', 'hidden', 'important');
      line.style.setProperty('margin', '0', 'important');
      line.style.setProperty('padding', '0', 'important');
    });
  }

  function startHiddenFreeGiftObserver() {
    var target = document.querySelector('.cart-item-list__body');
    if (!target || target.__glazybooHiddenGiftObserver) return;

    target.__glazybooHiddenGiftObserver = true;

    var observer = new MutationObserver(function () {
      hideHiddenFreeGiftRowsImmediately();
    });

    observer.observe(target, {
      childList: true,
      subtree: true
    });
  }

  function markBogoUiFromCart(cart) {
    var giftData = getGiftMap(cart);
    var giftMap = giftData.map;

    document.querySelectorAll('[data-glazyboo-bogo-slot]').forEach(function (slotElement) {
      var slot = String(slotElement.getAttribute('data-glazyboo-bogo-slot') || '');
      var gift = giftMap[slot];
      var selectedVariantId = gift ? Number(gift.variant_id) : null;

      slotElement.querySelectorAll('[data-glazyboo-bogo-select]').forEach(function (button) {
        var buttonVariantId = Number(button.getAttribute('data-variant-id'));
        button.classList.toggle(
          'is-selected',
          selectedVariantId ? buttonVariantId === selectedVariantId : button.classList.contains('is-selected')
        );
      });

      var status = slotElement.querySelector('[data-glazyboo-bogo-status]');
      if (status) status.textContent = gift ? 'Free pair added' : 'Adding free pair...';
    });
  }

  function reconcileGifts(options) {
    options = options || {};

    if (syncing && !options.allowWhileSyncing) {
      return Promise.resolve(false);
    }

    syncing = true;
    setRootSyncing(true);

    return getCart()
      .then(function (cart) {
        var paidSlots = buildPaidSlots(cart);
        var giftData = getGiftMap(cart);
        var giftMap = giftData.map;
        var operations = [];

        giftData.extras.forEach(function (item) {
          operations.push(function () {
            return changeLineQuantity(item.key, 0);
          });
        });

        cart.items.forEach(function (item) {
          if (!isGiftItem(item)) return;

          var slotNumber = Number(getSlot(item));

          if (!slotNumber || slotNumber > paidSlots.length) {
            operations.push(function () {
              return changeLineQuantity(item.key, 0);
            });
          } else if (!isFreeGiftVariant(item)) {
            operations.push(function () {
              return changeLineQuantity(item.key, 0);
            });
          } else if (Number(item.quantity) !== 1) {
            operations.push(function () {
              return changeLineQuantity(item.key, 1);
            });
          }
        });

        if (!options.cleanupOnly) {
          paidSlots.forEach(function (slotData, index) {
            var slot = String(index + 1);

            if (!giftMap[slot]) {
              operations.push(function () {
                return addGift(slotData.defaultFreeVariantId, slot, slotData.defaultStyle);
              });
            }
          });
        }

        if (!operations.length) {
          updateBogoBodyScope();
          markBogoUiFromCart(cart);
          return false;
        }

        return runOperationsSequentially(operations).then(function () {
          return getCart().then(function (updatedCart) {
            updateBogoBodyScope();
            markBogoUiFromCart(updatedCart);
            return true;
          });
        });
      })
      .then(function (changed) {
        syncing = false;
        setRootSyncing(false);
        hideHiddenFreeGiftRowsImmediately();
        revealCartAnimatedElements();
    lockBogoQuantityInputs();
        return changed;
      })
      .catch(function (error) {
        syncing = false;
        setRootSyncing(false);
        hideHiddenFreeGiftRowsImmediately();
        revealCartAnimatedElements();
    lockBogoQuantityInputs();
        console.warn('[GlazyBoo BOGO]', error);
        return false;
      });
  }

  function askSymmetryToRefresh() {
    document.dispatchEvent(new CustomEvent('theme:cartchanged', {
      bubbles: true,
      cancelable: false,
      detail: {
        glazybooBogoSync: true
      }
    }));
  }

  function requestFinalCartRefresh() {
    /*
      Safety refresh for very fast quantity changes:
      after the hidden BOGO gifts are synced, ask Symmetry to merge the cart again
      so totals cannot stay stale.
    */
    setTimeout(function () {
      askSymmetryToRefresh();
      hideHiddenFreeGiftRowsImmediately();
    }, 120);

    setTimeout(function () {
      hideHiddenFreeGiftRowsImmediately();
      setCartMask(false);
    }, 850);
  }

  /*
    This is called directly by the patched theme.js after native cart quantity/remove
    updates have been posted, but before Symmetry refreshes the visible cart HTML.
  */
  window.GlazyBooBogoBeforeCartRefresh = function () {
    if (!isCartPage()) {
      return Promise.resolve(false);
    }

    setCartMask(true);

    return reconcileGifts({
      cleanupOnly: false,
      allowWhileSyncing: false
    }).then(function (bogoChanged) {
      return reconcileHaloBundles().catch(function (error) {
        console.warn('[GlazyBoo Halo cart page sync]', error);
        return false;
      }).then(function (haloChanged) {
        var changed = !!bogoChanged || !!haloChanged;
        hideHiddenFreeGiftRowsImmediately();

        if (changed) {
          requestFinalCartRefresh();
        } else {
          setTimeout(function () {
            setCartMask(false);
          }, 650);
        }

        return changed;
      });
    }).catch(function (error) {
      setCartMask(false);
      console.warn('[GlazyBoo BOGO theme hook]', error);
      return false;
    });
  };

  function changeSlot(slot, freeVariantId, styleName) {
    if (syncing) return;

    syncing = true;
    setRootSyncing(true);
    setCartMask(true);

    var slotContainer = document.querySelector('[data-glazyboo-bogo-slot="' + String(slot) + '"]');

    if (slotContainer) {
      slotContainer.querySelectorAll('[data-glazyboo-bogo-select]').forEach(function (button) {
        button.classList.toggle(
          'is-selected',
          Number(button.getAttribute('data-variant-id')) === Number(freeVariantId)
        );
      });

      var status = slotContainer.querySelector('[data-glazyboo-bogo-status]');
      if (status) status.textContent = 'Updating free pair...';
    }

    getCart()
      .then(function (cart) {
        var giftData = getGiftMap(cart);
        var existing = giftData.map[String(slot)];
        var chain = Promise.resolve();

        if (existing && Number(existing.variant_id) === Number(freeVariantId)) {
          return false;
        }

        if (existing) {
          chain = chain.then(function () {
            return changeLineQuantity(existing.key, 0);
          });
        }

        chain = chain.then(function () {
          return addGift(freeVariantId, slot, styleName);
        });

        return chain.then(function () {
          return true;
        });
      })
      .then(function (changed) {
        syncing = false;
        setRootSyncing(false);

        if (changed) {
          askSymmetryToRefresh();
          setTimeout(hideHiddenFreeGiftRowsImmediately, 20);
          setTimeout(function () { setCartMask(false); }, 650);
        } else {
          setCartMask(false);
          return getCart().then(markBogoUiFromCart);
        }
      })
      .catch(function (error) {
        syncing = false;
        setRootSyncing(false);
        setCartMask(false);

        if (slotContainer) {
          var status = slotContainer.querySelector('[data-glazyboo-bogo-status]');
          if (status) status.textContent = 'Please try again';
        }

        console.warn('[GlazyBoo BOGO style]', error);
      });
  }


  document.addEventListener('keydown', function (event) {
    var input = event.target.closest('[data-glazyboo-paid-line="true"] .cart-item__quantity-input, [data-glazyboo-paid-line="true"] input[name^="updates"]');
    if (!input) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
  }, true);

  document.addEventListener('beforeinput', function (event) {
    var input = event.target.closest('[data-glazyboo-paid-line="true"] .cart-item__quantity-input, [data-glazyboo-paid-line="true"] input[name^="updates"]');
    if (!input) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
  }, true);

  document.addEventListener('paste', function (event) {
    var input = event.target.closest('[data-glazyboo-paid-line="true"] .cart-item__quantity-input, [data-glazyboo-paid-line="true"] input[name^="updates"]');
    if (!input) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
  }, true);

  document.addEventListener('focusin', function (event) {
    var input = event.target.closest('[data-glazyboo-paid-line="true"] .cart-item__quantity-input, [data-glazyboo-paid-line="true"] input[name^="updates"]');
    if (!input) return;

    input.blur();
  }, true);

  document.addEventListener('click', function (event) {
    if (!document.body.classList.contains('glazyboo-bogo-cart-mask-active')) return;

    var bogoControl = event.target.closest('.quantity-up, .quantity-down, .cart-item__remove, a[href*="/cart/change"], [data-glazyboo-bogo-select]');
    if (!bogoControl) return;

    if (
      bogoControl.closest('[data-glazyboo-paid-line="true"]') ||
      bogoControl.closest('[data-glazyboo-bogo-root]')
    ) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('change', function (event) {
    if (!document.body.classList.contains('glazyboo-bogo-cart-mask-active')) return;

    var bogoInput = event.target.closest('.cart-item__quantity-input, input[name^="updates"]');
    if (!bogoInput || !bogoInput.closest('[data-glazyboo-paid-line="true"]')) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
  }, true);

  document.addEventListener('click', function (event) {
    var styleButton = event.target.closest('[data-glazyboo-bogo-select]');
    if (!styleButton) return;

    event.preventDefault();

    var slot = styleButton.getAttribute('data-slot');
    var freeVariantId = styleButton.getAttribute('data-variant-id');
    var styleName = styleButton.getAttribute('data-style-name') || '';

    changeSlot(slot, freeVariantId, styleName);
  });

  document.addEventListener('click', function (event) {
    if (!isCartPage() || !hasRoot()) return;

    var nativeBogoControl = event.target.closest('.quantity-up, .quantity-down, .cart-item__remove, a[href*="/cart/change"]');
    if (!nativeBogoControl || !nativeBogoControl.closest('[data-glazyboo-paid-line="true"]')) return;

    setCartMask(true);
    hideHiddenFreeGiftRowsImmediately();
  }, true);

  document.addEventListener('change', function (event) {
    if (!isCartPage() || !hasRoot()) return;

    var nativeBogoInput = event.target.closest('.cart-item__quantity-input, input[name^="updates"]');
    if (!nativeBogoInput || !nativeBogoInput.closest('[data-glazyboo-paid-line="true"]')) return;

    setCartMask(true);
    hideHiddenFreeGiftRowsImmediately();
  }, true);

  document.addEventListener('click', function (event) {
    var checkoutButton = event.target.closest('[name="checkout"], button[value="checkout"], input[value="checkout"]');
    if (!checkoutButton || !hasRoot() || checkoutInProgress) return;

    var form = checkoutButton.closest('form');
    if (!form) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    checkoutInProgress = true;
    checkoutButton.setAttribute('aria-busy', 'true');
    setCartMask(true);

    reconcileGifts({ cleanupOnly: false }).then(function () {
      var hiddenCheckout = form.querySelector('input[name="checkout"][type="hidden"]');

      if (!hiddenCheckout) {
        hiddenCheckout = document.createElement('input');
        hiddenCheckout.type = 'hidden';
        hiddenCheckout.name = 'checkout';
        hiddenCheckout.value = 'Checkout';
        form.appendChild(hiddenCheckout);
      }

      form.submit();
    }).catch(function () {
      checkoutInProgress = false;
      checkoutButton.removeAttribute('aria-busy');
      setCartMask(false);
    });
  }, true);

  document.addEventListener('theme:cartchanged', function () {
    if (!isCartPage()) return;

    updateBogoBodyScope();
    hideHiddenFreeGiftRowsImmediately();
    revealCartAnimatedElements();
    lockBogoQuantityInputs();

    setTimeout(function () {
      setCartMask(false);
    }, 700);
  });

  document.addEventListener('DOMContentLoaded', function () {
    if (!isCartPage()) return;

    updateBogoBodyScope();
    startHiddenFreeGiftObserver();
    hideHiddenFreeGiftRowsImmediately();
    revealCartAnimatedElements();
    lockBogoQuantityInputs();

    /*
      Initial page load / direct cart visit:
      sync gifts once, then trigger native refresh only if needed.
    */
    reconcileGifts({
      cleanupOnly: false
    }).then(function (bogoChanged) {
      return reconcileHaloBundles().catch(function (error) {
        console.warn('[GlazyBoo Halo initial cart sync]', error);
        return false;
      }).then(function (haloChanged) {
        if (bogoChanged || haloChanged) {
          askSymmetryToRefresh();
        }
      });
    });
  });
})();


/* =========================================================
   GlazyBoo Shared BOGO Urgency Countdown — v89
   One 5-minute visual countdown for lash BOGO and Halo 1+1.
   - Does NOT reset on lash style, Halo quantity, or AJAX cart refreshes.
   - When it reaches 00:00, it starts a fresh 5-minute cycle.
   - The same sessionStorage end time is used by cart page and overlay.
   - If both promotions are present, only one urgency block is rendered.
   ========================================================= */
(function () {
  var TIMER_SECONDS = 5 * 60;
  var STORAGE_KEY = 'glazyboo_bogo_reserve_timer_ends_at_v1';
  var timerInterval = null;

  function nowMs() {
    return Date.now ? Date.now() : new Date().getTime();
  }

  function formatTime(totalSeconds) {
    var minutes = Math.floor(totalSeconds / 60);
    var seconds = totalSeconds % 60;

    return String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
  }

  function getTimerNodes() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-glazyboo-reserve-timer]'));
  }

  function getStoredEndsAt() {
    try {
      return parseInt(window.sessionStorage.getItem(STORAGE_KEY), 10) || 0;
    } catch (error) {
      return 0;
    }
  }

  function setStoredEndsAt(endsAt) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, String(endsAt));
    } catch (error) {}
  }

  function getOrCreateEndsAt() {
    var endsAt = getStoredEndsAt();

    if (!endsAt || endsAt <= nowMs()) {
      endsAt = nowMs() + (TIMER_SECONDS * 1000);
      setStoredEndsAt(endsAt);
    }

    return endsAt;
  }

  function startGlazyBogoUrgencyCountdown() {
    var timerNodes = getTimerNodes();
    if (!timerNodes.length) return;

    if (timerInterval) {
      clearInterval(timerInterval);
      timerInterval = null;
    }

    var endsAt = getOrCreateEndsAt();

    function render() {
      var remaining = Math.ceil((endsAt - nowMs()) / 1000);

      if (remaining <= 0) {
        endsAt = nowMs() + (TIMER_SECONDS * 1000);
        setStoredEndsAt(endsAt);
        remaining = TIMER_SECONDS;
      }

      getTimerNodes().forEach(function (node) {
        node.textContent = formatTime(remaining);
      });
    }

    render();

    timerInterval = setInterval(render, 1000);
  }

  document.addEventListener('DOMContentLoaded', startGlazyBogoUrgencyCountdown);

  /*
    AJAX cart refreshes re-render the timer node.
    Restarting the interval is okay now because the end time is preserved,
    so style changes no longer reset the countdown.
  */
  document.addEventListener('theme:cartchanged', function () {
    setTimeout(startGlazyBogoUrgencyCountdown, 120);
  });

  document.addEventListener('shopify:section:load', function () {
    setTimeout(startGlazyBogoUrgencyCountdown, 120);
  });
})();



/* =========================================================
   GlazyBoo Shared BOGO Urgency Winner — black bar
   The completed urgency A/B test is locked to black_bar and is shared by
   both the GlazyLash BOGO and Halo 1+1 deal. Existing attribution keys stay
   unchanged for reporting compatibility and Kaching attributes are untouched.
   ========================================================= */
(function () {
  var STORAGE_KEY = 'glazyboo_bogo_urgency_variant_v1';
  var ATTRIBUTE_VARIANT = 'glazyboo_bogo_urgency_variant';
  var ATTRIBUTE_TIMER = 'glazyboo_bogo_urgency_timer';
  var ATTRIBUTE_VERSION = 'glazyboo_bogo_urgency_test_version';
  var syncingAttributes = false;
  var lastSyncedValue = '';

  function getBogoUrgencyVariant() {
    var winner = 'black_bar';

    // Replace any previous no_bar assignment so returning visitors
    // immediately receive the winning black-bar experience.
    try {
      window.localStorage.setItem(STORAGE_KEY, winner);
    } catch (error) {}

    return winner;
  }

  function hasBogoInCartUi() {
    return !!document.querySelector('[data-glazyboo-bogo-root], [data-glazyboo-bogo-urgency], [data-glazyboo-reserved-deal-urgency]');
  }

  function applyBogoUrgencyVariant() {
    var variant = getBogoUrgencyVariant();

    document.body.classList.toggle('glazyboo-bogo-ab-black-bar', variant === 'black_bar');
    document.body.classList.toggle('glazyboo-bogo-ab-no-bar', variant === 'no_bar');

    document.querySelectorAll('[data-glazyboo-bogo-urgency]').forEach(function (block) {
      block.setAttribute('data-glazyboo-ab-variant', variant);
      block.style.display = '';
    });

    return variant;
  }

  function updateCartAttributesForTest() {
    if (!hasBogoInCartUi()) return;
    if (syncingAttributes) return;

    var variant = applyBogoUrgencyVariant();
    var syncKey = variant + '|5_min_reset|black_bar_winner_v1';

    if (lastSyncedValue === syncKey) return;

    syncingAttributes = true;

    fetch('/cart.js', {
      method: 'GET',
      cache: 'no-store',
      headers: {
        'Accept': 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Could not read cart');
        return response.json();
      })
      .then(function (cart) {
        var attributes = Object.assign({}, cart.attributes || {});

        attributes[ATTRIBUTE_VARIANT] = variant;
        attributes[ATTRIBUTE_TIMER] = '5_min_reset';
        attributes[ATTRIBUTE_VERSION] = 'black_bar_winner_v1';

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            attributes: attributes
          })
        });
      })
      .then(function (response) {
        if (!response.ok) throw new Error('Could not update cart attributes');
        lastSyncedValue = syncKey;
      })
      .catch(function (error) {
        console.warn('[GlazyBoo BOGO A/B attributes]', error);
      })
      .finally(function () {
        syncingAttributes = false;
      });
  }

  function scheduleBogoUrgencyAbSync() {
    applyBogoUrgencyVariant();

    setTimeout(updateCartAttributesForTest, 250);
  }

  document.addEventListener('DOMContentLoaded', scheduleBogoUrgencyAbSync);

  document.addEventListener('theme:cartchanged', function () {
    setTimeout(scheduleBogoUrgencyAbSync, 180);
  });

  // The custom overlay deliberately does not dispatch Symmetry's native
  // theme:cartchanged event because that can trigger a native section refresh.
  // Listen to the private custom-cart render event so the BOGO A/B attributes
  // are still written to Shopify order Additional details.
  document.addEventListener('glazyboo:custom-cart-rendered', function () {
    // The BOGO block already exists when this private event fires, so write
    // its attribution immediately instead of waiting for the normal delayed
    // DOM scan. This also protects very fast checkout clicks.
    setTimeout(function () {
      applyBogoUrgencyVariant();
      updateCartAttributesForTest();
    }, 0);
  });

  document.addEventListener('shopify:section:load', function () {
    setTimeout(scheduleBogoUrgencyAbSync, 180);
  });
})();


/* =========================================================
   GlazyBoo Mobile AJAX Overlap Fix Helper — v62
   Non-layout helper only. theme.js does the actual direct cart-item refresh.
   ========================================================= */
(function () {
  function relockBogoInputs() {
    document.querySelectorAll('[data-glazyboo-paid-line="true"] .cart-item__quantity-input, [data-glazyboo-paid-line="true"] input[name^="updates"]').forEach(function (input) {
      input.setAttribute('readonly', 'readonly');
      input.setAttribute('inputmode', 'none');
      input.setAttribute('aria-readonly', 'true');
      input.classList.add('glazyboo-bogo-qty-input-locked');
      input.title = 'Use the + and - buttons to update quantity';
    });
  }

  document.addEventListener('theme:cartchanged', function () {
    setTimeout(relockBogoInputs, 250);
    setTimeout(relockBogoInputs, 650);
  });
})();
